/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration"
import { CancelToken } from "axios";
import { IContact } from "../shared/interfaces";

const controller = 'Contacts';


const getContactSuggestions = (aooId: number, listId: string, searchValue: string, cancelToken?: CancelToken): Promise<IContact[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetContactSuggestions/${listId}`, { cancelToken: cancelToken, params: { searchValue } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getContactInfo = (aooId: number, listId: string, contactId: number, cancelToken?: CancelToken): Promise<IContact> => {
    return axiosInstance.get(`${controller}/${aooId}/GetContactInfo/${listId}/${contactId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getContactSuggestions,
    getContactInfo
}